/// <reference types="fhir" />

import { Component, Input, OnInit } from "@angular/core";

import {
  TopicItem,
  Topic,
  IRelevantSupportActionModalNavParams
} from "../../../app/models/types";
import { TopicCardPopover } from "./topic-card.popover/topic-card.popover";
import { PopoverController, ModalController } from "ionic-angular";
import { DiaprofilPatient } from "../../../app/models/diaprofil-patient";
import { RelevantSupportActionsModal } from "../../../modals/relevant-support-actions.modal/relevant-support-actions.modal";
import { OptionObject } from "@zitelab/ionic-fhir-questionnaires";
import { DatePipe } from "@angular/common";
import { EvaluationState } from "../../../app/store/reducers/evaluation.reducer";
import { DiaprofilProTask } from "../../../app/models/diaprofil-pro-task";
import {
  EventLoggingService,
  LogEventId
} from "../../../app/services/event-logging.service";

@Component({
  selector: "topic-card",
  templateUrl: "./topic-card.component.html"
})
export class TopicCard implements OnInit {
  @Input() topic: Topic;
  @Input() topicItems: TopicItem[];
  @Input() patient: DiaprofilPatient;
  @Input() task: DiaprofilProTask;
  @Input() evaluationState: EvaluationState;
  @Input()
  displaySettings: {
    enableOtherHighlightedAnswers: boolean;
    showNoteInput: boolean;
    enableTrendDisplay: boolean;
    colorBlindMode: boolean;
  };
  keyItems: TopicItem[] = [];
  otherItems: TopicItem[] = [];
  highlightedColors: {
    RED: boolean;
    YELLOW: boolean;
    GREEN: boolean;
    NONE: boolean;
  } = {
    RED: false,
    YELLOW: false,
    GREEN: false,
    NONE: false
  };
  otherItemsByColor: {
    RED: string[];
    YELLOW: string[];
    GREEN: string[];
    NONE: string[];
  } = {
    RED: [],
    YELLOW: [],
    GREEN: [],
    NONE: []
  };
  keyItemsByColor: {
    RED: string[];
    YELLOW: string[];
    GREEN: string[];
    NONE: string[];
  } = {
    RED: [],
    YELLOW: [],
    GREEN: [],
    NONE: []
  };
  hasRedItemsBeenShown: boolean = false;
  constructor(
    public popoverCtrl: PopoverController,
    private modalCtrl: ModalController,
    private datePipe: DatePipe,
    private eventLogging: EventLoggingService
  ) {}

  ngOnInit() {
    const symptomItemStatus = (item: TopicItem) => {
      const isSymptomsItem =
        item.config.valueBasedHealthTopic.topic === "SYMPTOMS";
      const isKeyItem = item.config.valueBasedHealthTopic.isKeyItem === true;
      let result = null;
      if (!isSymptomsItem || !isKeyItem) {
        return result;
      }
      const optionObj = item.answerInfo.optionObj as OptionObject;
      result =
        optionObj.colorInterpretation === "RED" ||
        optionObj.colorInterpretation === "YELLOW"
          ? "keyItem"
          : "otherItem";
      return result;
    };
    this.keyItems = this.topicItems
      .filter(
        item =>
          (item.config.valueBasedHealthTopic.isKeyItem === true &&
            item.config.valueBasedHealthTopic.topic !== "SYMPTOMS") ||
          symptomItemStatus(item) === "keyItem"
      )
      .map(item => {
        if (
          item.answerInfo.isEnabled &&
          item.config.valueBasedHealthTopic.topic !== "MENTAL_HEALTH"
        ) {
          // Special rule for WHO5
          const optionObj = item.answerInfo.optionObj as OptionObject;
          const color = optionObj.colorInterpretation;
          const arrayForColor =
            this.keyItemsByColor[color] || this.keyItemsByColor["NONE"];
          if (
            item.config.widgetType !== "StringWidget" &&
            item.config.widgetType !== "TextAreaWidget"
          ) {
            arrayForColor.push(item);
          }
        }
        return item;
      });
    this.otherItems = this.topicItems.filter(item => {
      return (
        item.config.valueBasedHealthTopic.isKeyItem === false ||
        item.config.valueBasedHealthTopic.topic === "MENTAL_HEALTH" ||
        symptomItemStatus(item) === "otherItem" // Special rule for WHO5
      );
    });
    this.otherItems.forEach(item => {
      if (item.answerInfo.isEnabled) {
        const optionObj = item.answerInfo.optionObj as OptionObject;
        const color = optionObj.colorInterpretation;
        const arrayForColor =
          this.otherItemsByColor[color] || this.otherItemsByColor["NONE"];
        if (
          item.config.widgetType !== "StringWidget" &&
          item.config.widgetType !== "TextAreaWidget"
        ) {
          arrayForColor.push(item);
        }
      }
    });
    if (this.otherItemsByColor.RED.length === 0) {
      this.hasRedItemsBeenShown = true;
    }
  }

  toogleColorHighlight(event, color: "RED" | "YELLOW" | "GREEN" | "NONE") {
    event.preventDefault();
    this.highlightedColors[color] = this.highlightedColors[color]
      ? false
      : true; // Toogle boolean value
    if (color === "RED" && this.highlightedColors[color] === true) {
      this.hasRedItemsBeenShown = true;
    }
  }

  openRelevantSupportActionsModal(items: TopicItem[], title) {
    this.eventLogging.saveEvent({
      event_id: LogEventId.OPEN_SUPPORT_ACTION_MODAL,
      event_src_location: "TopicCard",
      parent_task_uuid: this.task.task.id,
      qnr_response_uuid: this.task.response.id,
      patient_fhir_id: this.patient.fhirId,
      patient_full_name: this.patient.fullName,
      additional_info: {
        topicName: this.topic.id,
        items: items.map(x => x.config.name).join()
      }
    });
    debugger;
    const data: IRelevantSupportActionModalNavParams = {
      supportFor: {
        proItems: items,
        patientWishes: [],
        consultationTopics: [],
        scoreIds: []
      },
      patient: this.patient,
      modalType: "PRO_ITEM",
      modalTitle: title
    };
    const modal = this.modalCtrl.create(RelevantSupportActionsModal, data, {
      cssClass: "large-modal",
      enableBackdropDismiss: false
    });
    modal.present();
  }

  presentPopover(event) {
    const data = {
      topic: this.topic,
      topicItems: this.topicItems,
      patient: this.patient,
      task: this.task
    };
    const popover = this.popoverCtrl.create(TopicCardPopover, data);
    popover.present({
      ev: event
    });
  }

  createTrendTooltip(item: TopicItem) {
    if (item.trendInfo.prev.responseId === null) {
      return "Intet tidligere svar";
    }
    const date = this.datePipe.transform(
      item.trendInfo.prev.date,
      "dd-MM-yyyy"
    );
    const optionObj = item.trendInfo.prev.answerInfo.optionObj as OptionObject;
    return `${date}: ${optionObj.display}`;
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard.page/topic-card.component/topic-card.component.ts